import { render, staticRenderFns } from "./SubmittedPanel.vue?vue&type=template&id=d27b739e&"
import script from "./SubmittedPanel.vue?vue&type=script&lang=js&"
export * from "./SubmittedPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports